import { Card, CardBody } from "reactstrap";
import { EmptyStateProp } from "../../../../types/Applications";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import SearchNotFoundClass from "../../../../coreComponents/SearchNotFoundClass";

// This component displays an empty state message when no contacts are found.
const EmptyState: React.FC<EmptyStateProp> = ({ title }) => {
  return (
    <Card className="mb-0">
      {title && <CommonCardHeader headClass="d-flex" title={title} span={[{ text: "0 Contacts" }]} />}
      <CardBody>
        <SearchNotFoundClass word="Contact" />
      </CardBody>
    </Card>
  );
};
export default EmptyState;
